<template>
  <div id="bar-value" class="vx-row ">
    <div class="vx-col w-full sm:w-1/5 lg:w-1/5 xl:w-1/5">
      <div class="card" >
        <small> ยอดรวมน้ำมัน </small>
        <div>
          <p class="h7"><vs-icon icon="invert_colors"></vs-icon> {{setFormatNumber(totalOilVolume)}}  ลิตร</p>
        </div>
      </div>
    </div>
    <div class="vx-col w-full sm:w-1/5 lg:w-1/5 xl:w-1/5">
      <vx-tooltip text="ยอดรวมน้ำมัน * ราคาน้ำมัน">
        <div class="card" >
          <small> มูลค่าน้ำมัน </small>
          <div>
            <p class="h7"><vs-icon icon="invert_colors"></vs-icon> {{ setFormatNumber(Number(totalIsExciseRate).toFixed(2)) }} บาท</p>
          </div>
        </div>
      </vx-tooltip>
    </div>
    <div class="vx-col w-full sm:w-1/5 lg:w-1/5 xl:w-1/5">
      <vx-tooltip text="ยอดรวมน้ำมัน * 6.44">
        <div class="card" >
          <small>มูลค่าที่ขอยกเว้น/คืนภาษี</small>
          <div>
            <p class="h7"><vs-icon icon="invert_colors"></vs-icon> {{ setFormatNumber(Number(totalIsExciseExemption).toFixed(2)) }} บาท</p>
          </div>
        </div>
      </vx-tooltip>
    </div>
    <div class="vx-col w-full sm:w-1/5 lg:w-1/5 xl:w-1/5">
      <div class="card" >
        <small>ราคาน้ำมัน/ลิตร</small>
        <div>
          <p class="h7"><vs-icon icon="invert_colors"></vs-icon> {{oilPrice}} บาท</p>
        </div>
      </div>
    </div>
    <div class="vx-col w-full sm:w-1/5 lg:w-1/5 xl:w-1/5">    
      <div class="card" >
        <small>มูลค่า 1% กรณีสูญหาย</small>
        <div>
          <p class="h7"><vs-icon icon="invert_colors"></vs-icon> {{ setFormatNumber(Number(percentOfLost).toFixed(2)) }} บาท</p>
        </div>
      </div>
    </div>
  </div> 
</template>
<script>
import { formatNumber } from '@/utils/index';
import { mapState } from "vuex";

export default {
  name: "barValue",
  props: {
    // data: {
    //   type: Array,
    //   default: () => []
    // },
    totalOilVolume: {type: Number},
  },
  data() {
    return {
      formatNumber,
      maxWidth: 250,

      base: 0,
      totalIsExciseRate: 0,
      totalIsExciseExemption: 0,
      oilPrice: 0,
      percentOfLost: 0
    } 
  },
  async mounted() {
    await this.$store.dispatch("oilTransfer/getOilPrice");
    // console.log(this.lastOilPrice);
    this.totalIsExciseRate = this.totalOilVolume * this.lastOilPrice.price
    this.totalIsExciseExemption = this.totalOilVolume * 6.44
    this.oilPrice = this.lastOilPrice.price
    this.percentOfLost = (this.totalOilVolume * this.lastOilPrice.price) * 0.01
  },
  computed:{
    ...mapState({
     lastOilPrice: (state) => state.oilTransfer.oilPrice,
    })
  },
  methods:{
    setFormatNumber(data) {
      return formatNumber(Number(data));
    },
  },
  watch: {
    async totalOilVolume(newVal, oldVal) {
      if (!_.isEqual(newVal, oldVal)) {
        this.totalIsExciseRate = newVal * this.lastOilPrice.price
        this.totalIsExciseExemption = newVal * 6.44
        this.oilPrice = this.lastOilPrice.price
        this.percentOfLost = (newVal * this.lastOilPrice.price) * 0.01
      }
    },
  }
}
</script>
<style scoped>
.card{
  max-width: 300px;
  min-width: 137px;
  background-color: #F7F7F7;
  border-radius: 5px;
  padding: 2px;
}
</style>